<div>
  <form [formGroup]="toolForm">
    <div class="tool-config-component">
      <div class="tool-data-container">
        <mat-form-field>
          <mat-label>Tool ID</mat-label>
          <input matInput formControlName="toolId" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Tool name</mat-label>
          <input matInput formControlName="toolName" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Tool version</mat-label>
          <input matInput formControlName="version" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Tool installation status</mat-label>
          <input matInput formControlName="status" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Project</mat-label>
          <input matInput formControlName="project" readonly />
        </mat-form-field>
      </div>
      <div class="tool-details">
        <mat-form-field class="tool-description-field">
          <mat-label>Tool description</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            formControlName="toolDescription"
            readonly></textarea>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Program language</mat-label>
          <input matInput formControlName="programLanguage" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Author</mat-label>
          <input matInput formControlName="author" readonly />
        </mat-form-field>
        <div class="tool-controls">
          <button mat-stroked-button color="primary" (click)="openRegistrations()">
            Manage access
          </button>
          <button mat-stroked-button color="primary" (click)="openToolInstallationLogs()">
            Show installation logs
          </button>
          <button mat-stroked-button color="primary" (click)="triggerToolReinstallation()">
            Reinstall tool
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
